import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import SubNavigationItems, { SubNavigationItemProps } from "go-app/components/Navigation/SubNavigationItems";
import { selectOrganization } from "../../../../../../../services/organizations/selectors";

const SubscriptionsNavigation = () => {
	const { t } = useTranslation();
	const organization = useSelector(selectOrganization);
	const items: SubNavigationItemProps[] = [
		{
			title: t("common.word.subscriptions"),
			route: `/${organization.id}/subscriptions`,
			isActiveRoute: (_: any, location: any) => {
				return !location.pathname.includes("invoices");
			},
		},
		{
			title: t("modules.invoice.header.title"),
			route: `/${organization.id}/subscriptions/invoices`,
		},
	];
	return <SubNavigationItems title={t("common.word.subscriptions")} items={items} />;
};

export default SubscriptionsNavigation;
